// src/components/Wig.jsx
import React, { useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";


const ASSET_BASE =
  process.env.REACT_APP_ASSET_BASE_URL ||
  "https://pub-f0f38b8dd0224e2f89367893cf6bb0d7.r2.dev";

const wigUrl = (id) => `${ASSET_BASE}/wigs/${id}.glb`;

// Optional: tweak which meshes you tint (name-based)
function tintMaterial(mat, colorHex, variation = 0) {
  if (!mat) return mat;

  const m = mat.clone();

  const base = new THREE.Color(colorHex);
  base.offsetHSL(0, 0.08, variation + 0.08); // boosts saturation + lightness

  if (m.color) {
    m.color.copy(base);
  }

  // Softer, not shiny
  m.metalness = 0;
  m.roughness = 0.68;
  m.envMapIntensity = 0.12;

  // Do NOT use emissive for now — it was crushing dark tones
  if ("emissive" in m) {
    m.emissive.set("#000000");
    m.emissiveIntensity = 0;
  }

  m.needsUpdate = true;
  return m;
}

export default function Wig({ hair }) {
  const style = hair?.style ?? null;
  const color = hair?.color ?? "#4b2f20";

  const src = style ? wigUrl(style) : null;

  // Don't render if none chosen
  const gltf = useGLTF(src ?? wigUrl("hair_1")); // loader needs a string
  const scene = useMemo(() => {
    if (!style) return null;

    const root = gltf.scene.clone(true);
    root.position.set(0, 0, 0);
    root.scale.set(1, 1, 1);

let meshIndex = 0;

root.traverse((obj) => {
  if (!obj.isMesh) return;

 const variation = ((meshIndex % 5) - 2) * 0.045;
  meshIndex += 1;

  const mat = obj.material;

  if (Array.isArray(mat)) {
    obj.material = mat.map((m) => tintMaterial(m, color, variation) ?? m);
  } else {
    obj.material = tintMaterial(mat, color, variation) ?? mat;
  }
});

    root.updateMatrixWorld(true);
    return root;
  }, [gltf, style, color]);

  if (!style || !scene) return null;

  return <primitive object={scene} rotation={[0, 0, 0]} />;
}

// Preload all (optional)
[
  "hair_1","hair_2","hair_3","hair_4","hair_5",
  "hair_6","hair_7","hair_8","hair_9","hair_10",
  "hair_11","hair_12","hair_13","hair_14","hair_15",
  "hair_16","hair_17","hair_18","hair_19"
].forEach((id) => useGLTF.preload(wigUrl(id)));
